import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";

import Legal_img from "../../assets/img/contact.jpg";

export default function Legal() {
  const messages = defineMessages({
    breadcrumb: {
      id: "page.legal.breadcrumb",
      description: "page legal breadcrumb",
      defaultMessage: "Aviso Legal",
    },
    title: {
      id: "page.legal.pageTitle",
      description: "page legal title",
      defaultMessage: "Aviso Legal",
    },
    intro: {
      id: "page.legal.pageIntro",
      description: "page legal intro",
      defaultMessage:
        "INTEDOCS SOLUCIONES DIGITALES S.L, provista de CIF B64554629, actúa como titular, dinamizador y gestor de contenidos de la presente web. La entidad informa a los Usuarios que cumple con la vigente normativa de protección de datos, y con carácter especial, con el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo de 27 de abril de 2016 relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE (Reglamento general de protección de datos) y con la Ley de la Sociedad de Servicios de la Información y Comercio Electrónico, Ley 34/2002, de 11 de julio.",
    },
    dataTitleOne: {
      id: "page.legal.dataTitleOne",
      description: "legal data title one",
      defaultMessage: "Razón Social: ",
    },
    dataInfoOne: {
      id: "page.legal.dataInfoOne",
      description: "legal data info one",
      defaultMessage: "INTEDOCS SOLUCIONES DIGITALES S.L",
    },
    dataTitleTwo: {
      id: "page.legal.dataTitleTwo",
      description: "legal data title Two",
      defaultMessage: "CIF: ",
    },
    dataInfoTwo: {
      id: "page.legal.dataInfoTwo",
      description: "legal data info Two",
      defaultMessage: "B64554629",
    },
    dataTitleThree: {
      id: "page.legal.dataTitleThree",
      description: "legal data title Three",
      defaultMessage: "Dirección: ",
    },
    dataInfoThree: {
      id: "page.legal.dataInfoThree",
      description: "legal data info Three",
      defaultMessage: "Manuel Girona 16, Bajos 08034 Barcelona",
    },
    dataTitleFour: {
      id: "page.legal.dataTitleFour",
      description: "legal data title Four",
      defaultMessage: "Población: ",
    },
    dataInfoFour: {
      id: "page.legal.dataInfoFour",
      description: "legal data info Four",
      defaultMessage: "Barcelona",
    },
    dataTitleFive: {
      id: "page.legal.dataTitleFive",
      description: "legal data title Five",
      defaultMessage: "Código Postal: ",
    },
    dataInfoFive: {
      id: "page.legal.dataInfoFive",
      description: "legal data info Five",
      defaultMessage: "08034",
    },
    conceptTitle: {
      id: "page.legal.conceptTitle",
      description: "legal concept title",
      defaultMessage: "CONCEPTO DE USUARIO",
    },
    conceptText: {
      id: "page.legal.conceptText",
      description: "legal concept text",
      defaultMessage:
        "La utilización de la web (incluida su área privada) atribuye la condición de Usuario, e implica la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas en este Aviso Legal y en las Políticas de Privacidad en la versión publicada por INTEDOCS SOLUCIONES DIGITALES S.L. en el mismo momento en que el Usuario acceda a la web. En consecuencia, el Usuario debe leer atentamente el presente Aviso Legal y las Políticas de Privacidad en cada una de las ocasiones en que se proponga utilizar la web, puesto que puede tener modificaciones.",
    },
    linksTitle: {
      id: "page.legal.linksTitle",
      description: "legal links title",
      defaultMessage: "INFORMACIÓN SOBRE LOS LINKS",
    },
    linksText: {
      id: "page.legal.linksText",
      description: "legal links text",
      defaultMessage:
        "INTEDOCS SOLUCIONES DIGITALES S.L no se hace responsable de las webs no propias a las que se puede acceder mediante vínculos “links” o de cualquier contenido puesto a disposición por terceros. Cualquier uso de un vínculo o acceso a una web no propia es realizado por voluntad y riesgo exclusivo del usuario y INTEDOCS SOLUCIONES DIGITALES S.L no recomienda ni garantiza ninguna información obtenida a través de un vínculo ajeno a la web de INTEDOCS SOLUCIONES DIGITALES S.L ni se responsabiliza de ninguna pérdida, reclamación o perjuicio derivada del uso o mal uso de un vínculo, o de la información obtenida a través de él, incluyendo otros vínculos o webs, de la interrupción en el servicio o en el acceso, o del intento de usar o usar mal un vínculo, tanto al conectarse a la web de INTEDOCS SOLUCIONES DIGITALES S.L como al acceder a la información de otras webs desde la web de INTEDOCS SOLUCIONES DIGITALES S.L.",
    },
    externalTitle: {
      id: "page.legal.externalTitle",
      description: "legal external title",
      defaultMessage: "VÍNCULOS O ENLACES DESDE OTRAS WEBS EXTERNAS",
    },
    externalText: {
      id: "page.legal.externalText",
      description: "legal external text",
      defaultMessage:
        "Se prohíbe expresamente establecer vínculos desde páginas que contengan manifestaciones o propaganda de carácter racista, xenófobo, pornográfico, de apología del terrorismo, en contra de los Derechos Humanos o cualquier otro de carácter ilícito o contrario a la moral y al orden público. En ningún caso se podrá dar a entender, ni declarar que, INTEDOCS SOLUCIONES DIGITALES S.L, interviene, avala, promociona, participa o ha supervisado en forma alguna los contenidos de la página donde figure el enlace, ni tan sólo que consienta su incursión, excepto autorización expresa.",
    },
    policyTitle: {
      id: "page.legal.policyTitle",
      description: "legal policy title",
      defaultMessage: "POLITICA DE PRIVACIDAD",
    },
    policyText: {
      id: "page.legal.policyText",
      description: "legal policy text",
      defaultMessage:
        "INTEDOCS SOLUCIONES DIGITALES S.L, provista de CIF B64554629, actúa como titular, dinamizador y gestor de contenidos de la presente web. La entidad informa a los Usuarios que cumple con la vigente normativa de protección de datos, y con carácter especial, con el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo de 27 de abril de 2016 relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE (Reglamento general de protección de datos) y con la Ley de la Sociedad de Servicios de la Información y Comercio Electrónico, Ley 34/2002, de 11 de julio. En virtud de esta normativa se informa que los datos facilitados por el Usuario a través de los formularios de la web (incluida el Área Privada), serán incorporados y tratados en un tratamiento debidamente registrado en el RGAEPD del que es responsable INTEDOCS SOLUCIONES DIGITALES S.L, con la finalidad de atender la relación establecida entre las partes y amparada por la normativa en especial en materia de Prevención de Riesgos Laborales y demás legislación conexa. Los datos son confidenciales y su uso responde a los fines legalmente establecidos en cada momento determinado. Si lo desea puede acceder, rectificar, cancelar y oponerse al tratamiento de dichos datos mediante escrito dirigido a Manuel Girona 16, Bajos 08034 Barcelona. Para obtener más información acerca de nuestra Política de Privacidad, por favor diríjase al siguiente enlace ",
    },
    policyLink: {
      id: "page.legal.policyLink",
      description: "legal policy link",
      defaultMessage: "Política de Privacidad.",
    },
    cookiesTitle: {
      id: "page.legal.cookiesTitle",
      description: "legal cookies title",
      defaultMessage: "INFORMACIÓN SOBRE LA UTILIZACIÓN DE COOKIES",
    },
    cookiesText: {
      id: "page.legal.cookiesText",
      description: "legal cookies text",
      defaultMessage:
        "En esta web se pueden utilizar cookies. La finalidad de dichas cookies es mejorar el servicio que ofrecen a sus clientes y a nuestros visitantes. Si desea saber más sobre el uso de las cookies por parte de INTEDOCS SOLUCIONES DIGITALES S.L diríjase a nuestra ",
    },
    cookiesLink: {
      id: "page.legal.cookiesLink",
      description: "legal cookies link",
      defaultMessage: "Política de cookies.",
    },
    responsabilityTitle: {
      id: "page.legal.responsabilityTitle",
      description: "legal responsability title",
      defaultMessage: "RENUNCIA Y LIMITACIÓN DE LA RESPONSABILIDAD",
    },
    responsabilityText: {
      id: "page.legal.responsabilityText",
      description: "legal responsability text",
      defaultMessage:
        "INTEDOCS SOLUCIONES DIGITALES S.L informa que en todo momento implementa las medidas de seguridad oportunas a fin de presentar a los usuarios de la web informaciones y servicios adecuados, ciertos y actualizados; no obstante, se reserva el derecho de rectificación sobre aquellos aspectos que, eventualmente y de forma fortuita, puedan sufrir incorrecciones, desactualizaciones o errores. INTEDOCS SOLUCIONES DIGITALES S.L ha obtenido la información y los materiales incluidos en la web de fuentes consideradas como fiables, pero si bien se han tomado las medidas correspondientes por asegurar que la información contenida sea correcta, no garantiza que sea exacta o actualizada. También se advierte que los contenidos de esta web, tienen dos finalidades, una finalidad informativa en cuanto a la calidad, situación, servicios y tarifas y otra de venta de servicios, según lo previsto en el presente aviso legal y el resto de textos legales de la presente web.",
    },
    tecnicalTitle: {
      id: "page.legal.tecnicalTitle",
      description: "legal tecnical title",
      defaultMessage: "INDICACIONES SOBRE ASPECTOS TÉCNICOS",
    },
    tecnicalText: {
      id: "page.legal.tecnicalText",
      description: "legal tecnical text",
      defaultMessage:
        "INTEDOCS SOLUCIONES DIGITALES S.L declina cualquier responsabilidad en caso de que existan interrupciones o un mal funcionamiento de los servicios o contenidos ofrecidos en Internet, cualquiera que sea su causa. Asimismo, INTEDOCS SOLUCIONES DIGITALES S.L no se hace responsable por caídas de la red, pérdidas de información como consecuencia de dichas caídas, suspensiones temporales del fluido eléctrico o cualquier otro tipo de daño indirecto que le pueda ser causado a los Usuarios por causas ajenas a INTEDOCS SOLUCIONES DIGITALES S.L INTEDOCS SOLUCIONES DIGITALES S.L  no declara ni garantiza que los servicios o contenidos sean ininterrumpidos o que estén libres de errores, que los defectos sean corregidos, o que el servicio o el servidor que lo pone a disposición estén libres de virus u otros componentes nocivos, sin perjuicio de que INTEDOCS SOLUCIONES DIGITALES S.L  realiza sus mejores esfuerzos en evitar este tipo de incidentes. En caso de que el Usuario tomara determinadas decisiones o realizara acciones con base a la información incluida en cualquiera de los websites, se recomienda la comprobación de la información recibida con otras fuentes.",
    },
    copyTitle: {
      id: "page.legal.copyTitle",
      description: "legal copy title",
      defaultMessage: "PROPIEDAD INDUSTRIAL E INTELECTUAL",
    },
    copyText: {
      id: "page.legal.copyText",
      description: "legal copy text",
      defaultMessage:
        "Los contenidos prestados por INTEDOCS SOLUCIONES DIGITALES S.L así como los contenidos vertidos en la red a través de sus páginas web, constituyen una obra en el sentido de la legislación sobre propiedad intelectual por lo que se hallan protegidos por las leyes y convenios internacionales aplicables en la materia. Queda prohibida cualquier forma de reproducción, distribución, comunicación pública, transformación, puesta a disposición y, en general, cualquier otro acto de explotación pública referido tanto a las páginas web como a sus contenidos e información, sin el expreso y previo consentimiento y por escrito de INTEDOCS SOLUCIONES DIGITALES S.L En consecuencia, todos los contenidos que se muestran en los diferentes websites y en especial, diseños, textos, gráficos, logotipos, iconos, botones, software, nombres comerciales, marcas, dibujos industriales o cualesquiera otros signos susceptibles de utilización industrial y comercial están sujetos a derechos de propiedad intelectual e industrial de INTEDOCS SOLUCIONES DIGITALES S.L o de terceros titulares de los mismos que han autorizado debidamente su inclusión en los diferentes websites. Los contenidos, imágenes, formas, opiniones, índices y demás expresiones formales que formen parte de las páginas web, así como el software necesario para el funcionamiento y visualización de las mismas, constituyen asimismo una obra en el sentido del Derecho de Autor y quedan, por lo tanto, protegidas por las convenciones internacionales y legislaciones nacionales en materia de Propiedad intelectual que resulten aplicables. El incumplimiento de lo señalado implica la comisión de graves actos ilícitos y su sanción por la legislación civil y penal. Queda prohibido todo acto por virtud del cual los Usuarios de los servicios o contenidos puedan explotar o servirse comercialmente, directa o indirectamente, en su totalidad o parcialmente, de cualquiera de los contenidos, imágenes, formas, índices y demás expresiones formales que formen parte de las páginas web sin permiso previo y por escrito de INTEDOCS SOLUCIONES DIGITALES S.L En concreto, y sin carácter exhaustivo, quedan prohibidos los actos de reproducción, distribución, exhibición, transmisión, retransmisión, emisión en cualquier forma, almacenamiento en soportes físicos o lógicos (por ejemplo, disquetes o disco duro de ordenadores), digitalización o puesta a disposición desde bases de datos distintas de las pertenecientes a las autorizadas por INTEDOCS SOLUCIONES DIGITALES S.L  así como su traducción, adaptación, arreglo o cualquier otra transformación de dichas opiniones, imágenes, formas, índices y demás expresiones formales que se pongan a disposición de los Usuarios a través de los servicios o contenidos, en tanto tales actos estén sometidos a la legislación aplicable en materia de Propiedad intelectual, industrial o de protección de la imagen. INTEDOCS SOLUCIONES DIGITALES S.L es libre de limitar el acceso a las páginas web, y a los productos y/o servicios en ella ofrecidos, así como la consiguiente publicación de las opiniones, observaciones, imágenes o comentarios que los Usuarios puedan hacerle llegar a través del correo electrónico. INTEDOCS SOLUCIONES DIGITALES S.L en este sentido, podrá establecer, si lo considera oportuno, sin perjuicio de la única y exclusiva responsabilidad de los Usuarios, los filtros necesarios a fin de evitar que a través de sus páginas web puedan verterse en la red contenidos u opiniones, considerados como racistas, xenófobos, discriminatorios, pornográficos, difamatorios o que, de cualquier modo, fomenten la violencia o la diseminación de contenidos claramente ilícitos o nocivos. Aquellos Usuarios que envíen a las páginas web de INTEDOCS SOLUCIONES DIGITALES S.L a su departamento de sugerencias, observaciones, opiniones o comentarios por medio del servicio de correo electrónico, salvo que expresen de manera cierta e inconfundible lo contrario, en los casos en los que por la naturaleza de los servicios o contenidos ello sea posible, se entiende que autorizan a INTEDOCS SOLUCIONES DIGITALES S.L  para la reproducción, distribución, exhibición, transmisión, retransmisión, emisión en cualquier formato, almacenamiento en soportes físicos o lógicos (por ejemplo, disquetes o disco duro de ordenadores), digitalización, puesta a disposición desde bases de datos pertenecientes a INTEDOCS SOLUCIONES DIGITALES S.L  traducción, adaptación, arreglo o cualquier otra transformación de tales observaciones, opiniones o comentarios, por todo el tiempo de protección de derecho de autor que esté previsto legalmente. Asimismo, se entiende que esta autorización se hace a título gratuito, y que por el solo hecho de enviar por correo electrónico tales observaciones, opiniones o comentarios, los Usuarios declinan cualquier pretensión remuneratoria por parte de INTEDOCS SOLUCIONES DIGITALES S.L. De acuerdo con lo señalado en el párrafo anterior, INTEDOCS SOLUCIONES DIGITALES S.L queda autorizada igualmente para proceder a la modificación o alteración de tales observaciones, opiniones o comentarios, a fin de adaptarlos a las necesidades de formato editorial de las páginas web, sin que por ello pueda entenderse que existe en absoluto cualquier tipo de lesión de cualesquiera de las facultades morales de derecho de autor que los Usuarios pudieran ostentar sobre aquéllas. Quedan prohibidos cualesquiera de los recursos técnicos, lógicos o tecnológicos por virtud de los cuales un tercero pueda beneficiarse, directa o indirectamente, con o sin lucro, de todos y cada uno de los contenidos, formas, índices y demás expresiones formales que formen parte de las páginas web, o del esfuerzo llevado a cabo por INTEDOCS SOLUCIONES DIGITALES S.L para su funcionamiento. En concreto, queda prohibido todo enlace, frame o vínculo similar que pueda establecerse en dirección a las páginas web de INTEDOCS SOLUCIONES DIGITALES S.L sin el consentimiento previo, expreso y por escrito de EL CLIENTE. Cualquier trasgresión de lo dispuesto en este punto será considerada como lesión de los legítimos derechos de Propiedad intelectual de INTEDOCS SOLUCIONES DIGITALES S.L sobre las páginas web y todos los contenidos de las mismas. INTEDOCS SOLUCIONES DIGITALES S.L no asumirá responsabilidad alguna ante consecuencias derivadas de las conductas y actuaciones antes citadas, del mismo modo que no asumirá responsabilidad alguna por los contenidos, servicios, productos, etc., de terceros a los que se pueda acceder directamente o a través de banners, enlaces, links, hyperlinks, framing o vínculos similares desde los websites de INTEDOCS SOLUCIONES DIGITALES S.L. Quedan prohibidos cualesquiera de los recursos técnicos, lógicos o tecnológicos por virtud de los cuales un tercero pueda beneficiarse, directa o indirectamente, con o sin lucro, de todos y cada uno de los contenidos, formas, índices y demás expresiones formales que formen parte de las páginas web, o del esfuerzo llevado a cabo por INTEDOCS SOLUCIONES DIGITALES S.L  para su funcionamiento. En concreto, queda prohibido todo link, hyperlink, framing o vínculo similar que pueda establecerse en dirección a las páginas web de INTEDOCS SOLUCIONES DIGITALES S.L  sin el consentimiento previo, expreso y por escrito de INTEDOCS SOLUCIONES DIGITALES S.L. Cualquier trasgresión de lo dispuesto en este punto será considerada como lesión de los legítimos derechos de Propiedad intelectual de EL CLIENTE sobre las páginas web y todos los contenidos de las mismas. INTEDOCS SOLUCIONES DIGITALES S.L no asumirá responsabilidad alguna ante consecuencias derivadas de las conductas y actuaciones antes citadas, del mismo modo que no asumirá responsabilidad alguna por los contenidos, servicios, productos, etc., de terceros a los que se pueda acceder directamente o a través de banners, enlaces, frames o vínculos similares desde los websites de INTEDOCS SOLUCIONES DIGITALES S.L",
    },
  });

  return (
    <>
      <section className="contact-page half-wrapper responsive-multimedia-off">
        <div className="half-breadcrumbs color">
          <ol
            className="breadcrumbs-list"
            itemScope
            itemType="http://schema.org/BreadcrumbList"
          >
            <li
              className="breadcrumbs-list-element active"
              itemProp="itemListElement"
              itemScope
              itemType="http://schema.org/ListItem"
            ></li>
          </ol>
        </div>
        <div className="wrapper">
          <div className="wrap-contact-page">
            <header className="contact-page-header">
              <div className="wrap-contact-header">
                <h1 className="contact-header-title">
                  <FormattedMessage {...messages.title} />
                </h1>
              </div>
            </header>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-text">
                  <FormattedMessage {...messages.intro} />
                </p>
              </div>
            </div>
            <div className="contact-page-details">
              <div className="wrap-contact-details">
                <div className="contact-details-element">
                  <div className="wrap-details-element">
                    <div className="details-element-header">
                      <div className="wrap-details-header">
                        <p className="details-header-title">
                          <FormattedMessage {...messages.dataTitleOne} />
                        </p>
                      </div>
                    </div>
                    <div className="details-element-content">
                      <div className="wrap-details-content">
                        <p className="details-content-text">
                          <FormattedMessage {...messages.dataInfoOne} />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="contact-details-element">
                  <div className="wrap-details-element">
                    <div className="details-element-header">
                      <div className="wrap-details-header">
                        <p className="details-header-title">
                          <FormattedMessage {...messages.dataTitleTwo} />
                        </p>
                      </div>
                    </div>
                    <div className="details-element-content">
                      <div className="wrap-details-content">
                        <p className="details-content-text">
                          <FormattedMessage {...messages.dataInfoTwo} />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="contact-details-element">
                  <div className="wrap-details-element">
                    <div className="details-element-header">
                      <div className="wrap-details-header">
                        <p className="details-header-title">
                          <FormattedMessage {...messages.dataTitleThree} />
                        </p>
                      </div>
                    </div>
                    <div className="details-element-content">
                      <div className="wrap-details-content">
                        <p className="details-content-text">
                          <FormattedMessage {...messages.dataInfoThree} />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="contact-details-element">
                  <div className="wrap-details-element">
                    <div className="details-element-header">
                      <div className="wrap-details-header">
                        <p className="details-header-title">
                          <FormattedMessage {...messages.dataTitleFour} />
                        </p>
                      </div>
                    </div>
                    <div className="details-element-content">
                      <div className="wrap-details-content">
                        <p className="details-content-text">
                          <FormattedMessage {...messages.dataInfoFour} />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="contact-details-element">
                  <div className="wrap-details-element">
                    <div className="details-element-header">
                      <div className="wrap-details-header">
                        <p className="details-header-title">
                          <FormattedMessage {...messages.dataTitleFive} />
                        </p>
                      </div>
                    </div>
                    <div className="details-element-content">
                      <div className="wrap-details-content">
                        <p className="details-content-text">
                          <FormattedMessage {...messages.dataInfoFive} />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-title">
                  <FormattedMessage {...messages.conceptTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.conceptText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-title">
                  <FormattedMessage {...messages.linksTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.linksText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-title">
                  <FormattedMessage {...messages.externalTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.externalText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-title">
                  <FormattedMessage {...messages.policyTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.policyText} />
                  <a href="/policy">
                    <FormattedMessage {...messages.policyLink} />
                  </a>
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-title">
                  <FormattedMessage {...messages.cookiesTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.cookiesText} />
                  <a href="/cookies">
                    <FormattedMessage {...messages.cookiesLink} />
                  </a>
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-title">
                  <FormattedMessage {...messages.responsabilityTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.responsabilityText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-title">
                  <FormattedMessage {...messages.linksTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.linksText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-title">
                  <FormattedMessage {...messages.tecnicalTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.tecnicalText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-title">
                  <FormattedMessage {...messages.copyTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.copyText} />
                </p>
              </div>
            </div>
            <div className="half-multimedia">
              <div className="wrap-half-multimedia">
                <div className="half-multimedia-box">
                  <div className="wrap-multimedia-box">
                    <figure
                      className="multimedia-box-element"
                      role="img"
                      data-lazyimg={Legal_img}
                    ></figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
